import { ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  ["WHAT I DO", "what-i-do"],
  ["EXPERIENCE", "experience"],
  ["CONTACT", "contact"],
];

const PulseDot = () => (
  <span className="relative flex h-1.5 w-1.5">
    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent opacity-75" />
    <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-accent" />
  </span>
);

export default function Nav() {
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-ink/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <button
          data-testid="nav-logo"
          onClick={() => scrollToId("top")}
          className="flex items-center gap-3"
          aria-label="Back to top"
        >
          <Logo className="h-6 w-6 text-white" />
          <span className="font-display text-sm font-bold tracking-tight text-white">A. Falkenberg</span>
          <span className="font-mono text-[10px] tracking-[0.2em] text-fog">PHD</span>
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map(([label, id]) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => scrollToId(id)}
              className="font-mono text-[11px] tracking-[0.2em] text-fog transition-colors hover:text-white"
            >
              {label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-5">
          <span className="hidden items-center gap-2 font-mono text-[10px] tracking-[0.25em] text-accent sm:flex">
            <PulseDot />
            AVAILABLE
          </span>
          <button
            data-testid="nav-cta"
            onClick={() => scrollToId("contact")}
            className="group flex items-center gap-2 bg-white px-4 py-2 font-mono text-[11px] tracking-[0.2em] text-ink transition-colors hover:bg-accent"
          >
            GET IN TOUCH
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </button>
        </div>
      </div>
    </header>
  );
}
